export const CONTACT_STATUSES = [
  { labelId: 'ui-organizations.contactPeople.status.active', value: false },
  { labelId: 'ui-organizations.contactPeople.status.inactive', value: true },
];
